import React, { useState } from 'react';
import TabHeader from '../../Components/TabHeader/TabHeader';
import { IVA_TAB, IvaTabs } from './constants';
import IvaTabBar from './Elements/IvaTabBar';
import GuidelinesSection from './Elements/GuidelinesSection';
import MappingsSection from './Elements/MappingsSection';
import VersionsSection from './Elements/VersionsSection';

const IvaPolicies = () => {
  const [activeTab, setActiveTab] = useState(IVA_TAB.GUIDELINES);

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-6 tw-p-2'>
      <TabHeader
        title='IVA Policies'
        subTitle='Manage complaint-type IVA guidelines, category mappings and versions'
      />

      <IvaTabBar tabs={IvaTabs} activeKey={activeTab} onChange={setActiveTab} />

      {activeTab === IVA_TAB.GUIDELINES && <GuidelinesSection />}
      {activeTab === IVA_TAB.MAPPINGS && <MappingsSection />}
      {activeTab === IVA_TAB.VERSIONS && <VersionsSection />}
    </div>
  );
};

export default IvaPolicies;
